import { getToken, net } from '../../admincore'
import { API_URL } from '../../utils/constants'

const { get, postJson } = net

// eslint-disable-next-line
export const getScheduledOrders = (companyId, params) => get(`${API_URL}/${companyId}/scheduled`, params, getToken())
export const importScheduledOrders = (companyId, params) => postJson(`${API_URL}/${companyId}/import-orders`, params, getToken())
